export const getUser = () => {
    const user = sessionStorage.getItem("user") || localStorage.getItem("user");
    debugger;
    if (!user) return null;
    try {
        return JSON.parse(user);
    } catch (e) {
        return null;
    }
}

export const setUser = (user) => {
    sessionStorage.removeItem("user");
    localStorage.removeItem("user");
    sessionStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("user", JSON.stringify(user));
    debugger;
    debugger;
}

export const setOrbitList = (list) => {
    localStorage.setItem('orbitList', JSON.stringify(list));
}

export const getOrbitList = () => {
    return JSON.parse(localStorage.getItem('orbitList'));
}

export const setOrbitId = (orbitId) => {
    const userStr = sessionStorage.getItem("user") || localStorage.getItem("user");
    const user = JSON.parse(userStr);
    user.defaultOrbit = orbitId;

    sessionStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("user", JSON.stringify(user));
}

export const setDisplayTiles = (value) => {
    localStorage.setItem("displayTiles", value);
}

export const getDisplayTiles = () => {
    return localStorage.getItem("displayTiles") ? JSON.parse(localStorage.getItem("displayTiles")) : false;
}

export const setDiagnosticId = (diagnosticId) => {
    const userStr = sessionStorage.getItem("user") || localStorage.getItem("user");
    const user = JSON.parse(userStr);
    user.dIdList = diagnosticId;

    sessionStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("user", JSON.stringify(user));
}

export const setDiagnosticList = (diagnosticList) => {
    const userStr = sessionStorage.getItem("user") || localStorage.getItem("user");
    const user = JSON.parse(userStr);
    user.diagnosticList = diagnosticList;

    sessionStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("user", JSON.stringify(user));
}

export const getExpiration = () => {
    const expiresIn = sessionStorage.getItem("expiresIn") || localStorage.getItem("expiresIn");
    return expiresIn ? expiresIn : null;
}

export const getLoginScreenStatus = () => {
    return localStorage.getItem("loginScreen") ? localStorage.getItem("loginScreen")  === 'true' : null;
}

export const setLoginScreenStatus = (loginScreen) => {
    localStorage.setItem("loginScreen", loginScreen);
}


